module.exports = __webpack_public_path__ + "img/camera.2a79a73a.svg";